var React = require('react');

function Accordion (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M7.219.976a1,1,0,0,1,1.562,0l5.919,7.4A1,1,0,0,1,13.919,10H2.081A1,1,0,0,1,1.3,8.375Z","fill":"currentColor"})));
}

Accordion.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Accordion;

Accordion.default = Accordion;
